module.exports = __webpack_public_path__ + "static/media/healthy-life-lifestyle-rest-svgrepo-com.6a86e94b.svg";